module.exports = __webpack_public_path__ + "img/jpg.bbc1878b.svg";